import numeral from "numeral";

export default {
    format(number) {
        return numeral(number).format("0,0[.]00");
    }
};
